;(function () {
  angular.module('contrast.date').directive('calendarDate', function () {
    return {
      restrict: 'A',
      scope: {
        calendarDate: '=',
        calendarDateFunction: '&'
      },
      link: function (scope, elem, attrs) {
        scope.hasLink = function () {
          return angular.isDefined(attrs.calendarDateFunction)
        }
      },
      templateUrl: 'views/common/calendar_date.html'
    }
  })
})()
